<template>
  <div>
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Usuários</li>
        </ol>

        <v-card>
          <v-card-title>
            <h3>Usuários</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :headers="headers" :items="usuarios" :search="search" :pagination.sync="pagination" class="less-space">
            <template slot="items" slot-scope="props">
              <td>{{ padronizaData(props.item.created_at)}}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.master }}</td>
              <td class="text-xs-right many-buttons">
                <span v-if="!(props.item.deleted_at)">
                  <router-link
                    class="btn mr-2 text-white blue-grey darken-4"
                    :to="'usuarios/'+props.item.id"
                  >
                    <i class="fa fa-eye"></i> Detalhes
                  </router-link>
                </span>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      headers: [
        { text: "Data de criação", value: "created_at" },
        { text: "Nome", value: "name" },
        { text: "E-Mail", value: "email"},
        { text: "Usuário Principal", value: "master"},
        { text: "", value: ""}
      ],
      usuarios: [],
      isLoading: false
    };
  },
  mounted() {
    var self = this;

    self.isLoading = true;
    ajax("get", "users")
      .then(res => {
        self.isLoading = false;
        self.usuarios = res;
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error);
      });
  },
  methods: {

  }
};
</script>